@use '~/theme/theme' as *;

.loader {
  border: 2px solid currentcolor;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1.4s ease-in-out infinite;

  &[data-size='extrasmall'] {
    border-width: 1px;
    width: spacing(1.5);
    height: spacing(1.5);
  }

  &[data-size='small'] {
    width: spacing(2);
    height: spacing(2);
  }

  &[data-size='medium'] {
    width: spacing(2.5);
    height: spacing(2.5);
  }

  &[data-size='large'] {
    width: spacing(3);
    height: spacing(3);
  }

  &[data-size='extralarge'] {
    width: spacing(5);
    height: spacing(5);
    border-width: 3px;
  }

  &[data-size='huge'] {
    width: spacing(16);
    height: spacing(16);
    border-width: spacing(1);
    animation-duration: 0.8s;
  }
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
